export const sanitizeOTP = (value: string) => {
    let sanitizedValue = value.replace(/\./g, "");
    if (sanitizedValue.length > 6) {
        sanitizedValue = sanitizedValue.slice(0, 6);
    }
    return sanitizedValue;
};
